import ltAddonDetailSummary from 'html/addon/lt-addon-detail-summary.html';
import App from 'app/app.js';
import 'app/directive/LtAddOnDetailSummaryCtrl.js';

function LtAddOnDetailSummaryDirective() {
  return {
    restrict: 'E',
    scope: {
      isScrollable: '=',
      orderLines: '=',
      editIndex: '=',
      onSave: '&',
      upgradeOptions: '=',
      hasLookValidationError: '=',
      availableEnhancements: '='
    },
    template: ltAddonDetailSummary,
    controller: 'LtAddOnDetailSummaryCtrl',
    controllerAs: 'addOnDetailSummary'
  };
}

App.directive('ltAddOnDetailSummary', [LtAddOnDetailSummaryDirective]);
